import { Controller } from "stimulus"
import Swiper, { Autoplay, Navigation, EffectCoverflow } from 'swiper';

// 用在首頁上方的banner
export default class extends Controller {
  static targets = ['swiper', 'swiperPrev', 'swiperNext']

  swiper = null

  connect() {
    this.swiper = new Swiper(this.swiperTarget, {
      modules: [ Autoplay, Navigation, EffectCoverflow ],
      loop: true,
      effect: 'coverflow',
      slidesPerView: 1.6,
      centeredSlides: true,
      spaceBetween: 24,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 50,
        modifier: 0.8,
        slideShadows: true
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.swiperNextTarget,
        prevEl: this.swiperPrevTarget,
      },
      breakpoints: {
        // 平板
        705: {
          slidesPerView: 2,
          spaceBetween: 32,
          coverflowEffect: {
            depth: 100
          }
        },
        // 桌面
        1024: {
          slidesPerView: 2.8,
          spaceBetween: 40,
          coverflowEffect: {
            depth: 100
          }
        }
      }
    });
  }
  disconnect() {
    this.swiper.destroy()
    this.swiper = null
  }
}
